import React from 'react'
import './experience.css'
import {BsFillPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Develpoment</h3>
          <div className="experience__content">
          <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>React</h4>
                <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>JavaScript</h4>
               <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Tailwind</h4>
               <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>BootStrap</h4>
               <small className='text-light'>Intermediate</small>
              </div>
            </article>
            

            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>CSS</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>

            

            

            
          </div>
{/* ////////////////////////////////////////////////////// */}
        </div>
        <div className="experience__backend">
        <div className="experience__frontend">
          <h3>Backend Develpoment</h3>
          <div className="experience__content">
            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Node Js</h4>
               <small className='text-light'>Intermediate</small>
              </div>
            </article>

            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>MongoDb</h4>
               <small className='text-light'>Intermediate</small>
              </div>
            </article>

            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>Express</h4>
               <small className='text-light'>Basic</small>
              </div>
            </article>

            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>MySql</h4>
               <small className='text-light'>In Progress...</small>
              </div>
            </article>

            

           
          </div>

        </div>
        </div>
        <div className="experience__backend">
        <div className="experience__frontend">
          <h3>Programming Languages</h3>
          <div className="experience__content">
          <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>C/C++</h4>
               <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>Java</h4>
               <small className='text-light'>Experienced</small>
              </div>
            </article>
          <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>Python</h4>
               <small className='text-light'>Basic</small>
              </div>
            </article>
            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>Assembly language 8086</h4>
               <small className='text-light'>Advanced</small>
              </div>
            </article>

           
            
            

            
          </div>

        </div>
        </div>

        <div className="experience__backend">
        <div className="experience__frontend">
          <h3>Technical Skills</h3>
          <div className="experience__content">
          <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>Object-oriented programming (OOP)</h4>
               <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>AI</h4>
               <small className='text-light'>Intermediate</small>
              </div>
            </article>
            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
                <h4>Machine Learning</h4>
               <small className='text-light'>Basic</small>
              </div>
            </article>

            
            <article className='experience__detaild'>
              <BsFillPatchCheckFill className='experience__details-icon' />
              <div>
               <h4>Deep Learning</h4>
               <small className='text-light'>In Progress...</small>
              </div>
            </article>


           
          </div>

        </div>
        </div>
      </div>
    </section>
  )
}

export default Experience
